<template>
  <div class="min-vh-100 bg-gradient-primary flex items-center justify-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-7 col-lg-8">
          <div class="text-center">
            <div class="error mx-auto" data-text="404">404</div>
            <p class="lead text-gray-800 mb-5">页面未找到</p>
            <p class="text-gray-500 mb-0">您访问的页面不存在</p>
            <a href="/dashboard" class="btn btn-primary mt-4">
              <i class="bi bi-arrow-left"></i> 返回首页
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-gradient-primary {
  background: linear-gradient(135deg, #4e73df 0%, #224abe 100%);
}

.error {
  font-size: 12rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.8);
}

.lead {
  font-size: 1.5rem;
  font-weight: 300;
}
</style>